<template>
  <div class="cms">
    <template v-if="contents_type === 'block_contents'">
      <BlockContents
        :location_code="location_code"
        @hasContents="onHasContents"
      />
    </template>

    <template v-else-if="contents_type === 'special_page'">
      <SpecialPage
        :view_type="view_type"
        :page_limit="page_limit"
        :view_area="view_area"
        :show_more="show_more"
        @catchTitle="setTitle"
      />
    </template>

    <!-- <template v-if="contents_type === 'other_page'">
      <OtherPage :view_type="view_type" @catchTitle="setTitle" />
    </template>

    <template v-if="contents_type === 'header_footer'">
      <HeaderFooter :view_area="view_area" />
    </template> -->

    <template v-if="contents_type === 'news'">
      <!-- <template v-if="view_type === 'TopNewsImportant'">
        <TopNewsImportant :item_list="item_list" />
      </template> -->
      <template v-if="view_type === 'TopNewsNormal'">
        <TopNewsNormal :item_list="item_list" />
      </template>
      <!-- <template v-if="view_type === 'NewsList'">
        <NewsList :item_list="item_list" />
      </template>
      <template v-else>
        <News :view_type="view_type" @catchTitle="setTitle" />
      </template> -->
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import "@/general/components/cms/css/cms-utility.scss";
import BlockContents from "@/general/components/cms/contents_type/BlockContents.vue";

// import HeaderFooter from "@/components/cms/contents_type/HeaderFooter";
import SpecialPage from "@/general/components/cms/contents_type/SpecialPage.vue";
// import OtherPage from "@/components/cms/contents_type/OtherPage.vue";
// import TopNewsImportant from "@/components/cms/view_type/TopNewsImportant.vue";
import TopNewsNormal from "@/general/components/cms/view_type/TopNewsNormal.vue";
// import NewsList from "@/components/cms/view_type/NewsList.vue";
// import News from "@/components/cms/contents_type/News.vue";

@Options({
  props: {
    contents_type: { type: String, default: "" },
    location_code: { type: String, default: null },
    view_type: { type: String, default: null },
    view_area: { type: String, default: null },
    page_limit: { type: String, default: "" },
    item_list: { type: Array },
    show_more: { type: Boolean, default: true }
  },
  components: {
    BlockContents,
    // HeaderFooter,
    SpecialPage,
    // OtherPage,
    // TopNewsImportant,
    TopNewsNormal
    // NewsList,
    // News
  }
})
export default class CMS extends Vue {
  contents_type!: string;
  location_code!: string;
  view_type!: string;
  view_area!: string;
  page_limit!: string;
  item_list!: [];
  show_more!: boolean;

  setTitle(title: string) {
    this.$emit("catchTitle", title);
  }

  onHasContents(hasContents: boolean) {
    this.$emit("hasContents", hasContents);
  }
}
</script>

<style lang="scss"></style>
